import { Requirements } from 'app/routes';

import { CrmActivity, setCrmActivities } from 'store/autoReducers';

const CrmActivitiesRequirements: Requirements<{
    activities: CrmActivity[];
}> = {
    methods: () => ({ activities: { url: '/api/v1/crm/activity/statistics', cacheable: false } }),
    resolve: ({ result: { activities } }) => [setCrmActivities(activities)],
};
export default CrmActivitiesRequirements;
